import React from "react";
import "./BadgeChip.scss";

export default function BadgeChip({ children, className = "" , ...rest }) {
    return (
        <div className={`badge-chip ${className}`} {...rest}>
            {children}
        </div>
    );
}
